import { render, staticRenderFns } from "./regist2.vue?vue&type=template&id=5f7c3d1e&scoped=true&"
import script from "./regist2.vue?vue&type=script&lang=js&"
export * from "./regist2.vue?vue&type=script&lang=js&"
import style0 from "./regist2.vue?vue&type=style&index=0&id=5f7c3d1e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7c3d1e",
  null
  
)

export default component.exports